import React from "react";
import MenuItems from "./config/MenuItems";
import PermissionValidator from "../../../../../../shared/guard/PermissionValidator";
import { TabMenuContainer } from "../../../TabMenu/styles";

function DashboardTabMenu({
  active,
  setActive,
}: {
  active: string;
  setActive: (value: string) => void;
}): JSX.Element {
  const permissionValidator = new PermissionValidator();
  return (
    <TabMenuContainer>
      <ul>
        {MenuItems.map((item) => {
          if (!permissionValidator.hasPermission(item.permission)) {
            return null;
          }
          return (
            <li key={item.title}>
              <div
                className={active && active === item.title ? "active-nav-tab-item" : ""}
                onClick={() => {
                  setActive(item.queryString);
                }}
              >
                {item.title}
              </div>
            </li>
          );
        })}
      </ul>
    </TabMenuContainer>
  );
}

export default DashboardTabMenu;
